import { useState, MouseEvent } from 'react';
import { v4 as uuidv4 } from 'uuid';
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import style from './style';

type ActionMenuProps = {
  actions: {
    key: string,
    type: string,
    title: string,
    icon: JSX.Element,
    isDisabled?: boolean,
  }[],
  handleActions: (id: string, type: string, payload?: unknown) => void,
}

export const ActionMenu = ({
  actions,
  handleActions,
}: ActionMenuProps):JSX.Element | null => {
  const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState<null | HTMLElement>(null);
  const isActionMenuOpen = Boolean(actionMenuAnchorEl);

  const handleVertMenuIconClick = (e: MouseEvent<HTMLElement>) => {
    setActionMenuAnchorEl(e.currentTarget);
  };

  const handleVertActionMenuClose = () => {
    setActionMenuAnchorEl(null);
  };

  const onActionClicked = (key: string, type: string, payload?: unknown) => {
    handleActions(key, type, payload);

    handleVertActionMenuClose();
  };

  const renderItems = () => actions.map((action) => {
    return (
      <MenuItem
        key={ uuidv4() }
        disabled={ action.isDisabled || false }
        onClick={ () => onActionClicked(action.key, action.type) }
      >
        <ListItemIcon>
          { action.icon }
        </ListItemIcon>
        {action.title}
      </MenuItem>
    );
  });

  return (
    <>
      <IconButton
        aria-label={ style.aria.label }
        id={ style.aria.controls }
        aria-controls={ style.aria.id }
        aria-expanded={ isActionMenuOpen ? 'true' : undefined }
        aria-haspopup="true"
        onClick={ handleVertMenuIconClick }
        color="primary"
        sx={  { borderRadius: '48px' } }
      >
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={ actionMenuAnchorEl } open={ isActionMenuOpen } onClose={ handleVertActionMenuClose }>
        {renderItems()}
      </Menu>
    </>
  );
};
